import { apiEnvUrl, switchENV } from '../components/shared/Links';

const appointmentDetail = (externalGroupId) => `${switchENV(
  apiEnvUrl
)}/aps-services/service/client/v2/appointments/detail/${externalGroupId}?isEngagementBased=true`;

const availableDocumentsAPI = (externalGroupId) => `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v2/documents/available/${externalGroupId}`;

const cacheAPI = `${switchENV(
  apiEnvUrl
)}/aps-services/service/client/v1/cache/prime`;

const calendarTTAPI = `${switchENV(
  apiEnvUrl
)}/aps-services/service/client/v2/calendar/me`;

// GET and PUT
const clientPreferencesAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/preferences/v1/preferences`;

// GET and PUT
const clientUserStatus = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/user-status`;

const coClientConsentAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/coclient/join`;

const consentAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/consent/me`;

const consentEmail = (householdId) => `${switchENV(
    apiEnvUrl
)}/aps-services/service/associate/v1/advisor/financial-planning-group/${householdId}/request-consent`

const createEngagement = `${switchENV(
    apiEnvUrl
)}/aps-services/service/associate/v1/advisor/create-engagement`;

const createReleaseCandidateRequest = (externalGroupId) => `${switchENV(
    apiEnvUrl
)}/aps-services/service/associate/v1/advisor/create-release-candidate/${externalGroupId}`;

const cwvActionGetAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/action/active`;

const cwvActionPostAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/create/action`;

const emailInvitationAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/coclient/validation/invite`;

const emailInvitationEntityAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/coclient/validation/entity`;

// POST
const externalAccountsAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/external-accounts`;

// GET and POST
const financialAccountsAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/financial-accounts`;

const getLatestPlanAPI = (externalGroupId) => `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v2/document/latest/${externalGroupId}`;

// POST
const goalsAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/goals`;

// POST
const internalAccountsAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/internal-accounts`;

const inviteCoClientAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/coclient/invite`;

// GET and POST
const knowYourClientAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/know-your-client`;

// POST
const manualAccountsAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/manual-accounts`;

const newConsentAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/clients/me/summary`;

const pinValidationAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/coclient/validation/pin`;

const prospectusesAPI = `${switchENV(
    apiEnvUrl
)}/investment-vehicle-svc/service/graphql`;

// GET and POST
const rtqAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/rtq`;

const sessionAffinity = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/session`;

const ssoAPI = (externalGroupId) => `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v2/sign-on/me/${externalGroupId}`;

const ssoYodleeAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/aggregation/sign-on`;

const submitQuestionnaireAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/questionnaire/v1/submit`;

const yodleeError = `${switchENV(apiEnvUrl)}/aps-services/service/client/v1/external-account-status`;


export default {
    appointmentDetail,
    availableDocumentsAPI,
    cacheAPI,
    calendarTTAPI,
    clientPreferencesAPI,
    clientUserStatus,
    coClientConsentAPI,
    consentAPI,
    consentEmail,
    createEngagement,
    createReleaseCandidateRequest,
    cwvActionGetAPI,
    cwvActionPostAPI,
    emailInvitationAPI,
    emailInvitationEntityAPI,
    externalAccountsAPI,
    financialAccountsAPI,
    getLatestPlanAPI,
    goalsAPI,
    internalAccountsAPI,
    inviteCoClientAPI,
    knowYourClientAPI,
    manualAccountsAPI,
    newConsentAPI,
    pinValidationAPI,
    prospectusesAPI,
    rtqAPI,
    sessionAffinity,
    ssoAPI,
    ssoYodleeAPI,
    submitQuestionnaireAPI,
    yodleeError
};
